import { cleanJSONString } from '../../utils/cleanJSONString';
import { DataModelDesignerActionTypes } from './constants';
import { findNewObjects, findNewUniqueObjects, renameDuplicate, uniqueNameForObject, uniqueNumberForObject } from '../../utils/renameDuplicate';
import { DEFAULT_QUERY_OPTIONS } from '../../components/DataSourceRelationDesigner/queryBuilder';

interface State {
    dataModelId: any | "",
    allFieldList: any[],
    fieldList: any[],
    newFieldList: any[],
    queryOptions: any | {
        baseId: any | null,
        whereRows: any[],
        orderRows: any[],
        groupByRows: any[],
        aggregates: any | {},
    },
    shaxesList: any[],
    isChangeSelectedColumns: any,


    edgeList: any[]
}


const INIT_STATE = {
    dataModelId: "",
    allFieldList: [],
    fieldList: [],
    queryOptions: DEFAULT_QUERY_OPTIONS,
    newFieldList: [],
    shaxesList: [],
    isChangeSelectedColumns: false,



    edgeList: []
};

const DataModelDesign = (state: State = INIT_STATE, action: any): any => {
    switch (action.type) {
        case DataModelDesignerActionTypes.CHANGE_RESET_INITIAL_STATE:
            return {
                ...INIT_STATE,
            };

        case DataModelDesignerActionTypes.CHANGE_SEARCH_VALUE:
            if (action.payload === '') {
                return { ...state, fieldList: state.allFieldList };
            }
            const searchItems = state.allFieldList.filter((item: any) => item.name.toLowerCase().includes(action.payload))
            return {
                ...state,
                fieldList: searchItems,
            };

        case DataModelDesignerActionTypes.CHANGE_FIELD:
            return {
                ...state,
                fieldList: action.payload,
                allFieldList: action.payload,
            };

        case DataModelDesignerActionTypes.CHANGE_QUERY_OPTIONS_DATASOURCE:
            return {
                ...state,
                queryOptions: action.payload

            };

        // case DataModelDesignerActionTypes.CHANGE_COLUMN_ALIAS:
        //     var s_tShaxesFieldalias = state.shaxesList;
        //     const dtsfa = s_tShaxesFieldalias.findIndex((x: any) => x.uniqueId === action.payload.id)
        //     if (dtsfa !== -1) {
        //         const s_IsInSelected = s_tShaxesFieldalias[dtsfa].selectedColumns.findIndex((x: any) => x.name === action.payload.name && x?.tableName === action.payload?.tableName)
        //         if (s_IsInSelected !== -1) {
        //             s_tShaxesFieldalias[dtsfa].selectedColumns[s_IsInSelected].alias = action.payload.alias
        //         }

        //     }

        //     return {
        //         ...state,
        //         shaxesList: s_tShaxesFieldalias,
        //     };

        case DataModelDesignerActionTypes.CHANGE_COLUMN_ALIAS: {
            const { id, name, tableName, alias } = action.payload;
            const shaxesList = state.shaxesList.map((s: any) => {
                if (s.uniqueId !== id) return s;
                const selectedColumns = (s.selectedColumns || []).map((c: any) =>
                    (c.name === name && c?.tableName === tableName) ? { ...c, alias } : c
                );
                return { ...s, selectedColumns };
            });
            return { ...state, shaxesList };
        }

        case DataModelDesignerActionTypes.CHANGE_SELECTED_FIELD: {
            const shaxesList = state.shaxesList.map((s: any) => {
                if (s.uniqueId !== action.payload?.id) return s;
                const faray = (action.payload?.selectedColumnForm || []).map((sc: any) => {
                    const existing = (s.selectedColumns || []).find(
                        (x: any) => x.name === sc?.name && x?.tableName === sc?.tableName
                    );
                    const alias = existing ? existing.alias : sc.labelAlias;
                    return {
                        name: sc.name, alias,
                        radioItemId: sc?.radioItemId, selectedListId: sc?.selectedListId,
                        formListId: sc?.formListId, formNameList: sc?.formNameList,
                        fieldFormListId: sc?.fieldFormListId, fieldFormNameList: sc?.fieldFormNameList,
                        tableName: sc?.tableName, tableAlias: sc?.tableAlias
                    };
                });
                return { ...s, selectedColumns: faray };
            });
            return {
                ...state,
                shaxesList,
                isChangeSelectedColumns: !state.isChangeSelectedColumns
            };
        }

        // case DataModelDesignerActionTypes.CHANGE_SELECTED_FIELD:
        //     let s_isChangeSelectedColumns = state.isChangeSelectedColumns
        //     var s_tShaxesField = state.shaxesList;

        //     const dtsf = s_tShaxesField.findIndex((x: any) => x.uniqueId === action.payload?.id)
        //     if (dtsf !== -1) {
        //         let faray: any = [];

        //         action.payload?.selectedColumnForm?.map((s: any) => {
        //             const s_IsInSelected = s_tShaxesField[dtsf].selectedColumns.findIndex((x: any) => x.name === s?.name && x?.tableName === s?.tableName)
        //             let s_Alias = "";
        //             if (s_IsInSelected !== -1) {
        //                 s_Alias = s_tShaxesField[dtsf].selectedColumns[s_IsInSelected].alias;
        //                 faray.push({ name: s.name, alias: s_Alias, radioItemId: s?.radioItemId, selectedListId: s?.selectedListId, formListId: s?.formListId, formNameList: s?.formNameList, fieldFormListId: s?.fieldFormListId, fieldFormNameList: s?.fieldFormNameList, tableName: s?.tableName, tableAlias: s?.tableAlias })
        //             }
        //             else

        //                 faray.push({ name: s.name, alias: s.labelAlias, radioItemId: s?.radioItemId, selectedListId: s?.selectedListId, formListId: s?.formListId, formNameList: s?.formNameList, fieldFormListId: s?.fieldFormListId, fieldFormNameList: s?.fieldFormNameList, tableName: s?.tableName, tableAlias: s?.tableAlias })
        //         })
        //         s_tShaxesField[dtsf].selectedColumns = faray;
        //     }

        //     return {
        //         ...state,
        //         shaxesList: s_tShaxesField,
        //         isChangeSelectedColumns: !s_isChangeSelectedColumns
        //     };

        // case DataModelDesignerActionTypes.CHANGE_SHAXES:
        //     var tShaxes = state.shaxesList;

        //     if (action?.payload?.length > tShaxes?.length) {
        //         if (action.payload.length === tShaxes.length + 1) {
        //             const addedTables = findNewUniqueObjects(tShaxes, action.payload)
        //             if (addedTables) {
        //                 const addedTablesUniq = uniqueNumberForObject(addedTables[0], tShaxes)
        //                 const dts = action.payload.findIndex((x: any) => x.uniqueId === addedTablesUniq.uniqueId)
        //                 if (dts !== -1) {
        //                     action.payload[dts].uniqueNumber = addedTablesUniq.uniqueNumber
        //                     action.payload[dts].position = { x: (tShaxes.length * 100) + 10, y: (tShaxes.length * 50) + 10 }
        //                 }
        //                 tShaxes = action.payload
        //             }
        //         }
        //         else {
        //             tShaxes = action.payload
        //         }
        //     }
        //     else
        //         tShaxes = action.payload

        //     tShaxes?.map((s: any) => {
        //         let s_Columns: any = [];
        //         let s_Schema: any = [];
        //         if (s?.schema) {
        //             let cleanedSchema = cleanJSONString(s?.schema);
        //             s_Schema = cleanedSchema && JSON.parse(cleanedSchema);
        //         }

        //         s_Columns = s_Schema
        //         s.columns = s_Columns;
        //         let s_Position = s.position
        //     })

        //     return {
        //         ...state,
        //         shaxesList: tShaxes//action.payload,                                            
        //     };

        case DataModelDesignerActionTypes.CHANGE_SHAXES: {
            let tShaxes = action.payload;
            const prevShaxes = state.shaxesList;

            if (action?.payload?.length > prevShaxes?.length && action.payload.length === prevShaxes.length + 1) {
                const addedTables = findNewUniqueObjects(prevShaxes, action.payload);
                if (addedTables) {
                    const addedTablesUniq = uniqueNumberForObject(addedTables[0], prevShaxes);
                    tShaxes = action.payload.map((t: any) =>
                        t.uniqueId === addedTablesUniq.uniqueId
                            ? { ...t, uniqueNumber: addedTablesUniq.uniqueNumber, position: { x: (prevShaxes.length * 100) + 10, y: (prevShaxes.length * 50) + 10 } }
                            : t
                    );
                }
            }

            const shaxesList = tShaxes.map((s: any) => {
                let s_Schema: any = [];
                if (s?.schema) {
                    const cleanedSchema = cleanJSONString(s?.schema);
                    s_Schema = cleanedSchema && JSON.parse(cleanedSchema);
                }
                return { ...s, columns: s_Schema };
            });

            return { ...state, shaxesList };
        }

        // case DataModelDesignerActionTypes.CHANGE_SHAXES_REMOVE:
        //     var tShaxesRemove = state.shaxesList;
        //     var tEdgeList = state.edgeList;


        //     let s_isChangeSelectedColumnsRemove = state.isChangeSelectedColumns

        //     if (action.payload) {
        //         tShaxesRemove = tShaxesRemove.filter((x: any) => x.uniqueId !== action.payload)
        //         tEdgeList = tEdgeList.filter(x => x.source !== action.payload && x.target !== action.payload)
        //     }

        //     tShaxesRemove.map((s: any) => {
        //         let s_Columns: any = [];
        //         let s_Schema: any = [];
        //         if (s?.schema) {
        //             let cleanedSchema = cleanJSONString(s?.schema);
        //             s_Schema = cleanedSchema && JSON.parse(cleanedSchema);
        //         }

        //         s_Columns = s_Schema?.map((x: any) => {
        //             return { name: x.name, type: x.type }
        //         })
        //     })

        //     return {
        //         ...state,
        //         shaxesList: tShaxesRemove,
        //         edgeList: tEdgeList,
        //         isChangeSelectedColumns: !s_isChangeSelectedColumnsRemove
        //     };

        case DataModelDesignerActionTypes.CHANGE_SHAXES_REMOVE: {
            const shaxesList = action.payload
                ? state.shaxesList.filter((x: any) => x.uniqueId !== action.payload)
                : state.shaxesList;
            const edgeList = action.payload
                ? state.edgeList.filter((x: any) => x.source !== action.payload && x.target !== action.payload)
                : state.edgeList;

            return {
                ...state,
                shaxesList,
                edgeList,
                isChangeSelectedColumns: !state.isChangeSelectedColumns
            };
        }

        // case DataModelDesignerActionTypes.CHANGE_TABALE_POSITION:

        //     var s_tShaxes = state.shaxesList;

        //     const dts = s_tShaxes.findIndex((x: any) => x.uniqueId === action.payload.id)
        //     if (dts !== -1) {

        //         s_tShaxes[dts].position = action.payload.position
        //     }

        //     return {
        //         ...state,
        //         shaxesList: s_tShaxes,
        //     };

        case DataModelDesignerActionTypes.CHANGE_TABALE_POSITION: {
            const shaxesList = state.shaxesList.map((s: any) =>
                s.uniqueId === action.payload.id ? { ...s, position: action.payload.position } : s
            );
            return { ...state, shaxesList };
        }

        case DataModelDesignerActionTypes.CHANGE_NEWFIELD:
            const aNewFields = action.payload
            let taFieldList = [...state.fieldList, ...aNewFields]
            return {
                ...state,
                newFieldList: aNewFields,
                fieldList: taFieldList,
                allFieldList: taFieldList
            };

        case DataModelDesignerActionTypes.CHANGE_ADDNEWFIELD:
            const addedNewField = action.payload

            let tNewFields = [...state.newFieldList, addedNewField]
            let tFieldList = [...state.fieldList, addedNewField]

            return {
                ...state,
                newFieldList: tNewFields,
                fieldList: tFieldList,
                allFieldList: tFieldList
            };

        case DataModelDesignerActionTypes.CHANGE_DATAMODELID:
            return {
                ...state,
                dataModelId: action.payload,
            };

        case DataModelDesignerActionTypes.CHANGE_EDGES:
            return {
                ...state,
                edgeList: action.payload,
            };

        default:
            return state;
    }
};

export default DataModelDesign;
